import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../assets/css/adminpanel.css';

const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [form, setForm] = useState({ username: '', password: '' });
    const [editingId, setEditingId] = useState(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await axios.get('/api/admin/users', {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            setUsers(response.data);
        } catch (err) {
            console.error('Error fetching users:', err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            if (editingId) {
                await axios.put(
                    `/api/admin/users/${editingId}`,
                    form,
                    {
                        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                    }
                );
                setUsers((prev) =>
                    prev.map((user) => (user._id === editingId ? { ...user, ...form } : user))
                );
                setEditingId(null);
                setSuccess('User updated successfully!');
            } else {
                const response = await axios.post(
                    '/api/admin/users',
                    form,
                    {
                        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                    }
                );
                setUsers((prev) => [...prev, response.data]);
                setSuccess('User created successfully!');
            }
            setForm({ username: '', password: '' });
        } catch (err) {
            setError('Failed to save user. Please check the details.');
            console.error(err);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`/api/admin/users/${id}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            setUsers((prev) => prev.filter((user) => user._id !== id));
            setSuccess('User deleted successfully!');
        } catch (err) {
            setError('Failed to delete user.');
            console.error(err);
        }
    };

    const handleEdit = (user) => {
        setForm({ username: user.username, password: '' });
        setEditingId(user._id);
    };

    return (
        <div className="admin-panel container">
            <header className="card admin-header">
                <h2>Admin User Management</h2>
                <p>Manage admin users below. Add, edit, or delete users as needed.</p>
            </header>
            <div className="card">
                {error && <div className="error-message">{error}</div>}
                {success && <div className="success-message">{success}</div>}
                <form className="user-form" onSubmit={handleSubmit}>
                    <div className="form-row">
                        <label htmlFor="username">Username</label>
                        <input
                            id="username"
                            type="text"
                            placeholder="Username"
                            value={form.username}
                            onChange={(e) => setForm({ ...form, username: e.target.value })}
                            required
                        />
                    </div>
                    <div className="form-row">
                        <label htmlFor="password">
                            {editingId ? 'New Password (Optional)' : 'Password'}
                        </label>
                        <input
                            id="password"
                            type="password"
                            placeholder="Password"
                            value={form.password}
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                        />
                    </div>
                    <div className="button-container">
                        <button className="button button-primary" type="submit">
                            {editingId ? 'Update User' : 'Add User'}
                        </button>
                    </div>
                </form>
                <div className="table-container">
                    <table className="user-table">
                        <thead>
                            <tr>
                                <th>Username</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.length > 0 ? (
                                users.map((user) => (
                                    <tr key={user._id}>
                                        <td>{user.username}</td>
                                        <td className="actions">
                                            <button
                                                className="button button-small button-edit"
                                                onClick={() => handleEdit(user)}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="button button-small button-secondary"
                                                onClick={() => handleDelete(user._id)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">No users found. Add a new user!</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default UserManagement;